var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { memo, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Box, FormField, Label, Select, ShadowOverlay, Tooltip, getPaletteColor } from 'pcln-design-system';
import { Warning } from 'pcln-icons';
import generateTimeOptions from '../utils/generateTimeOptions';
var StyledLabel = /*#__PURE__*/styled(Label).withConfig({
  displayName: "TimePicker__StyledLabel",
  componentId: "sc-1chm2ig-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    z-index: ", ";\n  }\n"], ["\n  &&& {\n    z-index: ", ";\n  }\n"])), function (props) {
  return props.zIndex;
});
var StyledSelect = /*#__PURE__*/styled(Select).withConfig({
  displayName: "TimePicker__StyledSelect",
  componentId: "sc-1chm2ig-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    background-color: ", ";\n    height: ", ";\n    z-index: ", ";\n  }\n\n  & + svg {\n    z-index: ", ";\n  }\n"], ["\n  &&& {\n    background-color: ", ";\n    height: ", ";\n    z-index: ", ";\n  }\n\n  & + svg {\n    z-index: ", ";\n  }\n"])), getPaletteColor('background.lightest'), function (props) {
  return props.height;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.zIndex;
});
var WarningIcon = /*#__PURE__*/styled(Warning).withConfig({
  displayName: "TimePicker__WarningIcon",
  componentId: "sc-1chm2ig-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &&& {\n    z-index: ", ";\n  }\n"], ["\n  &&& {\n    z-index: ", ";\n  }\n"
/** @public */])), function (props) {
  return props.zIndex;
});
/** @public */
function TimePicker(_a) {
  var errorMessage = _a.errorMessage,
    hasShadowEffect = _a.hasShadowEffect,
    height = _a.height,
    label = _a.label,
    _b = _a.value,
    value = _b === void 0 ? '12:00' : _b,
    _c = _a.zIndex,
    zIndex = _c === void 0 ? 1 : _c,
    onChange = _a.onChange,
    props = __rest(_a, ["errorMessage", "hasShadowEffect", "height", "label", "value", "zIndex", "onChange"]);
  var _d = useState(false),
    isOpen = _d[0],
    setOpen = _d[1];
  var handleChange = useCallback(function (evt) {
    setOpen(false);
    onChange === null || onChange === void 0 ? void 0 : onChange(evt);
  }, []);
  var handleOpen = useCallback(function () {
    return setOpen(true);
  }, []);
  var handleClose = useCallback(function () {
    return setOpen(false);
  }, []);
  var handleKeyDown = useCallback(function (evt) {
    var key = evt.key;
    if (key === 'Escape') {
      setOpen(false);
    }
  }, []);
  var timeOptions = useMemo(function () {
    return generateTimeOptions();
  }, []);
  var showError = errorMessage !== undefined && errorMessage !== '';
  return React.createElement(React.Fragment, null, isOpen && hasShadowEffect && React.createElement(ShadowOverlay, {
    zIndex: zIndex,
    onClick: handleClose,
    "data-testid": 'time-picker-shadow-overlay'
  }), React.createElement(Box, null, React.createElement(FormField, null, label && React.createElement(StyledLabel, {
    zIndex: zIndex + 1
  }, label), React.createElement(StyledSelect, __assign({
    "aria-label": label,
    height: height,
    zIndex: zIndex,
    value: value,
    onBlur: handleClose,
    onChange: handleChange,
    onClick: handleOpen,
    onFocus: handleOpen,
    onKeyDown: handleKeyDown,
    color: errorMessage && 'error'
  }, props), timeOptions && timeOptions.map(function (time) {
    return React.createElement("option", __assign({
      key: time.value
    }, time), time.label);
  })), showError && React.createElement(WarningIcon, {
    color: 'error',
    size: 20,
    zIndex: zIndex
  })), !isOpen && showError && React.createElement(Tooltip, {
    bottom: true,
    right: true,
    color: 'error',
    zIndex: zIndex
  }, errorMessage)));
}
export default memo(TimePicker);
var templateObject_1, templateObject_2, templateObject_3;